import { type ReactNode, type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'Modal';
import { LessonPlayerBot } from 'TutorBotAiTutorChat';
import { useAppHeaderViewModel } from 'NavigationHelpers';
import { useErrorLogService } from 'ErrorLogging';
import { useCurrentUserIguanaObject } from 'FrontRoyalAngular';
import { SupportModalBody } from './SupportModalBody';

export const SupportModalPresentation: FC<{ onClose: () => void; AiTutorComponent: ReactNode | null }> = ({
    onClose,
    AiTutorComponent,
}) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'support.support' });

    const title = useMemo(() => t('haveQuestions'), [t]);

    return (
        <Modal title={title} size="2xl" onClose={onClose} dismissOnOverlayClick={false} dismissOnEscape={false}>
            <SupportModalBody AiTutorComponent={AiTutorComponent} />
        </Modal>
    );
};

export const SupportModal: FC<{ onClose: () => void; aiTutor: boolean }> = ({ onClose, aiTutor }) => {
    const currentUserIguanaObject = useCurrentUserIguanaObject();
    const AppHeaderViewModel = useAppHeaderViewModel();
    const ErrorLogService = useErrorLogService();

    const AiTutorComponent = useMemo(() => {
        if (!aiTutor) return null;
        const playerViewModel = AppHeaderViewModel.playerViewModel;
        playerViewModel?.launchBot(true);

        if (!currentUserIguanaObject || !playerViewModel?.botContentInfo) {
            ErrorLogService.notifyInProd('Cannot display LessonPlayerBot in SupportModal');
            return null;
        }

        return (
            <LessonPlayerBot
                currentUser={currentUserIguanaObject}
                contentInfo={playerViewModel.botContentInfo}
                uiContext={playerViewModel.botUiContext}
                initialMessage={playerViewModel.initialBotMessage}
                className="h-[500px] p-0 sm:p-0"
                supportTab
            />
        );
    }, [aiTutor, ErrorLogService, currentUserIguanaObject, AppHeaderViewModel.playerViewModel]);

    return <SupportModalPresentation onClose={onClose} AiTutorComponent={AiTutorComponent} />;
};
